import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Table, Button, OverlayTrigger, Tooltip, Badge } from 'react-bootstrap';
import { FaPlus, FaEdit, FaSearch, FaUndo, FaEye } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import SchoolFilter from "./SchoolFilter";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import { formateDatemdy } from "../../utils/Helper";
import Paginator from "../../components/common/Pagination";
import {
  capitalizeFirstLetterOfEveryWord
} from "../../utils/Helper";
const ManageSchool = () => {
  const permissionscontext = useMenuPermissions("/admin/school");
  const [schoolList, setSchoolList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [count, setCount] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();
  const limit = 10;

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);

  const headers = {
    "Content-Type": "application/json",
    "auth-token": authToken,
    "authorization": accessToken
  };

  useEffect(() => {
    fetchSchools();
  }, [currentPage, filters, searchTerm]);

  const fetchSchools = async () => {
    setLoading(true);
    try {
      const params = {
        skip: (currentPage - 1) * limit,
        limit: limit,
      };

      // Add search term if exists
      if (searchTerm && searchTerm.trim() !== "") {
        params.school_name = searchTerm.trim();
      }

      // Add filters if they exist
      if (filters.registration_number && filters.registration_number.trim() !== "") {
        params.registration_number = filters.registration_number.trim();
      }
      
      if (filters.school_code && filters.school_code.trim() !== "") {
        params.school_code = filters.school_code.trim();
      }
      
      if (filters.school_name && filters.school_name.trim() !== "") {
        params.school_name = filters.school_name.trim();
      }
      
      if (filters.status && filters.status !== "") {
        params.status = filters.status;
      }

      if (filters.school_type && filters.school_type !== "") {
        params.school_type = filters.school_type;
      }

      const queryString = new URLSearchParams(params).toString();

      const response = await APIServices.get(
        `/admin/school/list?${queryString}`,
        headers
      );

      if (response?.data?.status === true) {
        setSchoolList(response?.data?.data?.data || []);
        const total = response?.data?.data?.total || 0;
        setCount(total);
        setTotalCount(Math.ceil(total / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setSchoolList([]);
        setCount(0);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching schools:", error);
      showToast("Error fetching schools", "error");
      setSchoolList([]);
      setCount(0);
      setTotalCount(0);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (school) => {
    const newStatus = school.status === "Active" ? "Inactive" : "Active";
    
    // Create FormData for status update (as per API requirement)
    const formData = new FormData();
    formData.append("id", school.id);
    formData.append("status", newStatus);
    
    try {
      const res = await APIServices.put(
        `/admin/school/status`,
        formData,
        {
          ...headers,
          'Content-Type': 'multipart/form-data'
        }
      );

      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Status updated successfully", "success");
        // Refresh the list after status change
        fetchSchools();
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };



  const handleApplyFilter = (filterData) => {
    setFilters(filterData);
    setCurrentPage(1);
    setShowFilter(false);
  };

  const handleClearFilter = () => {
    setFilters({});
    setCurrentPage(1);
    setShowFilter(false);
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const getSerialNumber = (index) => {
    return (currentPage - 1) * limit + index + 1;
  };



  return (
    <>
      <div className="momList_inner todo_list_inner school_list_inner">
        <div className="mom_header d-flex align-items-center justify-content-between mb-3">
          <h1 className="font_blue_18 font-600">
            {`School Management (${count})`}
          </h1>

          <ul className="d-flex align-items-center mom_filter">
            <li
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setShowFilter(true)}
            >
              Filter By{" "}
              <img
                src="/images/Sort.svg"
                className="img-fluid ms-2"
                alt="Sort"
              />
            </li>
            <li>
              {permissionscontext.add == 1 && (
                <button
                  className="btn red_button d-flex align-items-center"
                  onClick={() => navigate("/admin/add-school")}
                >
                  <FaPlus className="me-1" />
                  Add School
                </button>
              )}
            </li>
          </ul>
        </div>

        <div className="todoList_table">
          <div className="table-responsive">
            <Table className="table">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: '3%' }}>#</th>
                  <th style={{ width: '12%' }}>School Name</th>
                  <th style={{ width: '8%' }}>School Code</th>
                  <th style={{ width: '10%' }}>Registration No.</th>
                  <th style={{ width: '8%' }}>Email</th>
                  <th style={{ width: '8%' }}>Mobile</th>
                  <th style={{ width: '10%' }}>City</th>
                  <th style={{ width: '8%' }}>School Type</th>
                  <th style={{ width: '6%' }}>Status</th>
                  <th style={{ width: '10%' }}>Created Date</th>
                  <th style={{ width: '8%' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="12" className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : schoolList.length > 0 ? (
                  schoolList.map((school, index) => (
                    <tr key={school.id}>
                      <td>{getSerialNumber(index)}</td>
                      <td>
                        <div className="school-name font-weight-bold">
                          <strong>{capitalizeFirstLetterOfEveryWord(school.school_name)}</strong>
                        </div>
                      </td>
                      <td>
                        
                          {school.school_code}
                      </td>
                      <td>
                       {school.registration_number}
                      </td>
                      <td> {school.email}
                      </td>
                      <td> {school.country_code_value}-{school.mobile}</td>
                      <td> {school.city_name}
                      </td>
                      <td>
                          {school.school_type}
                      </td>
                     
                      <td>
                        <Form className="Switch_toggle">
                          <input
                            type="checkbox"
                            id={`switch-${school.id}`}
                            checked={school.status === "Active"}
                            onChange={() => handleStatusChange(school)}
                            disabled={!permissionscontext.edit}
                          />
                          <label
                            className="position-relative"
                            htmlFor={`switch-${school.id}`}
                          >
                            Toggle
                          </label>
                        </Form>
                      </td>
                      <td>{formateDatemdy(school.created_at)}</td>
                      <td>
                        <ul className="d-flex align-items-center list-unstyled mb-0">
                          <li className="me-2">
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>View Details</Tooltip>}
                            >
                              <button
                                className="btn btn-sm btn-outline-info py-1"
                                onClick={() => {
                                  navigate(`/admin/school-detail/${school.id}`, {
                                    state: { row: school },
                                  });
                                }}
                              >
                                <FaEye />
                              </button>
                            </OverlayTrigger>
                          </li>
                          <li>
                            {permissionscontext.edit == 1 && (
                              <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip>Edit School</Tooltip>}
                              >
                                <button
                                  className="btn btn-sm btn-outline-success py-1"
                                  onClick={() => {
                                    navigate(`/admin/update-school/${school.id}`, {
                                      state: { row: school },
                                    });
                                  }}
                                >
                                  <FaEdit />
                                </button>
                              </OverlayTrigger>
                            )}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="12" className="text-center py-4">
                      <div className="text-muted">
                        <h5>No Schools found</h5>
                       
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <div className="pagination_box mt-4">
          {count > limit && (
            <Paginator
              currentPage={currentPage}
              totalPages={totalCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      {/* Filter Offcanvas */}
      {showFilter && (
        <SchoolFilter
          appliedFilters={filters}
          show={showFilter}
          onHide={() => setShowFilter(false)}
          onApplyFilter={handleApplyFilter}
          onClear={handleClearFilter}
        />
      )}

      <ToastContainer />
    </>
  );
};

export default ManageSchool;